/// 顶部 --- 统计数据
export const totalConfig = {
    
  "小U铺市率": "24%",
  "小U低糖铺市率": "6.0%",
  "YLD铺市率": "14%",
  "YLD低糖铺市率": "45%",
}

/// ----
export const tableDataArr1 = {
  "product": ["07-01","07-02","07-03","07-04","07-05","07-06","07-07","07-08"],
  
  "YLD铺市率": [21,21,12,14,13,16,15,17],
  "小U低糖铺市率": [5,5,6,8,3,7,5,2,7,6,4,5],
  "小U铺市率": [23,23,14,23,35,28,30,23,24],
  "YLD低糖铺市率": [52,51,64,44,54,54,52,49],
  // "YLD低糖铺市率": [8,22,3,12,30,30,19,12],
}

export const tableDataArr2 = {
  "product": ["北京","西北","豫皖","山东","华中","东北","华北","华东","上海","华南","西南","闽赣"],
  
    "YLD铺市率": [24,21,21,13,12,14,14,17,5,8,4,30],
    "小U低糖铺市率": [8,8,36,1,2,4,5,3,2,1,1,2],
    "小U铺市率": [8,22,3,12,30,30,19,12,62,41,47,6],
    "YLD低糖铺市率": [40,51,69,50,71,68,38,60,61,71,30,52],
    // "YLD低糖铺市率": [23,23,14,23,35,28,30,23,24,42,41,47],
}


export const tableDimensionArr = ["product",  "小U铺市率", "小U低糖铺市率","YLD铺市率", "YLD低糖铺市率"]

///
export const modernChartDataArr = [
  {
    "type": "line",
    "barWidth": "70%",
    "label": {
      "normal": {
        "show": true,
        "color": "black",
        "fontSize": 10,
        "position": "inside"
      }
    },
    "animationDuration": 2800,
    "animationEasing": "cubicInOut"
  },
  {
    "type": "line",
    "barWidth": "70%",
    "label": {
      "normal": {
        "show": true,
        "color": "black",
        "fontSize": 10,
        "position": "inside"
      }
    },
    "animationDuration": 2800,
    "animationEasing": "cubicInOut"
  },
  {
    "type": "line",
    "barWidth": "70%",
    "label": {
      "normal": {
        "show": true,
        "color": "black",
        "fontSize": 10,
        "position": "inside"
      }
    },
    "animationDuration": 2800,
    "animationEasing": "cubicInOut"
  },
  {
    "type": "line",
    "barWidth": "70%",
    "label": {
      "normal": {
        "show": true,
        "color": "black",
        "fontSize": 10,
        "position": "inside"
      }
    },
    "animationDuration": 2800,
    "animationEasing": "cubicInOut"
  },
 
]





// WEBPACK FOOTER //
// ./src/components/kpi/config/TwentyNew.js